export default "__VITE_ASSET__db806139__"